<template>
  <v-list-item v-if="address"
               :class="[isSelected ? 'selectedIndicator' : 'pr-4']">
    <AddressTemplate :Address="address" />
    <v-scroll-x-transition>
      <v-list-item-action v-if="hasBeenSelected || starred">
        <v-icon v-if="hasBeenSelected"
                color="quaternary">mdi-check</v-icon>
        <v-tooltip bottom
                   v-if="starred">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs"
                    v-on="on"
                    color="primary">mdi-star</v-icon>
          </template>
          <span v-text="$t('servicesystem.common_objects.commonterms.default')" />
        </v-tooltip>
      </v-list-item-action>
    </v-scroll-x-transition>
  </v-list-item>
</template>


<script>
import AddressTemplate from "@/components/Preview/Customer/AddressTemplate.vue";

export default {
  name: "CustomerAddressListItem",
  props: {
    address: Object,
    preselected: Object,
    starred: Boolean,
    singleline: Boolean,
  },
  components: { AddressTemplate },
  data: () => ({}),

  mounted() {
    
  },

  methods: {},

  computed: {
    isSelected() {
      if (this.preselected && this.preselected.Id === this.address.Id) {
        return true;
      } else {
        return false;
      }
    },

    hasBeenSelected() {
      if (this.preselected === this.address.Id) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.selectedIndicator {
  background-color: rgb(249, 249, 249) !important;
  z-index: 2;
  border: 1px solid #427aaf;
  border-left: 8px solid #427aaf;
  border-right: none;
}
.selectedIndicator.right {
  border-left: none !important;
  border-right: 8px solid #427aaf !important;
}
</style>